<template>
  <VueTelInput
    ref="component"
    :value="value"
    defaultCountry="es"
    :autoDefaultCountry="false"
    :autoFormat="false"
    :dropdownOptions="{
      showDialCodeInList: true,
      showDialCodeInSelection: false,
      showFlags: true,
      disabled: isDisabledFlags,
    }"
    :inputOptions="{
      autocomplete,
      id,
      maxlength: 25,
      name,
      placeholder,
    }"
    mode="auto"
    :preferredCountries="preferredCountries"
    :styleClasses="{
      'with-errors': error,
      'input-wrapper phone-input-alo': true,
    }"
    @focus="onFocus"
    @blur="onBlur"
    @country-changed="onCountryChanged"
    @input="onInput"
  />
</template>

<script>
import { validateContactPhoneField } from '@/Web/utils/contactPhoneValidation'

const VueTelInput = () =>
  Promise.all([import('vue-tel-input'), import('vue-tel-input/dist/vue-tel-input.css')]).then(
    ([{ VueTelInput }]) => VueTelInput
  )

export default {
  components: {
    VueTelInput,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'tel',
    },
    isDisabledFlags: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: null,
    },
    setError: {
      type: Function,
      default() {
        return null
      },
    },
  },

  data() {
    return {
      focused: false,
      formattedNumber: '',
      lastDialCode: '',
      preferredCountries: [
        'es',
        'ad',
        'at',
        'dk',
        'fr',
        'de',
        'ie',
        'it',
        'lu',
        'nl',
        'no',
        'pl',
        'pt',
        'se',
        'ch',
        'gb',
      ],
    }
  },

  computed: {
    proxyValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      },
    },
  },

  methods: {
    onFocus() {
      this.focused = true
    },
    onBlur() {
      this.focused = false
      this.$emit('input', this.formattedNumber)

      const errorKey = validateContactPhoneField(this.formattedNumber, this.name)

      if (errorKey) {
        this.$emit('setError', this.$t(`common.errors.${errorKey}`))
      } else if ('shipping_address_phone' !== this.name) {
        this.$emit('setError', '')
      }
    },
    onCountryChanged(country) {
      // Emit input on country changed
      this.$refs['component'].emitInput()
      this.$emit('input', this.formattedNumber)
    },
    onInput(number, phone) {
      this.formattedNumber = phone.nationalNumber ? '+' + phone.countryCallingCode + ' ' + phone.nationalNumber : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  @apply mt-1 shadow-sm sm:text-sm border-gray-300 rounded-md #{!important};

  ::v-deep input {
    padding: 0.5rem 0.75rem;
    @apply text-base sm:text-sm rounded-md;
  }
}
</style>
